import React from "react";
import { useI18n } from "@core/i18n/i18n";
import styled from "@emotion/styled";
import { useExercisePage } from "@ui/pages/exercise/hooks/use-exercise-page";

interface SelectedExerciseCountProps {
	className?: string;
}

export const SelectedExerciseCount: React.FC<SelectedExerciseCountProps> = ({ className }) => {
	const { format } = useI18n();
	const { selectedExercises } = useExercisePage();

	return (
		<Container className={className}>
			{format("exerciseListing.selectedExerciseCount", { selectedCount: selectedExercises.length })}
		</Container>
	);
};

const Container = styled.div`
	white-space: nowrap;
`;
